/**
 * Módulo de verificación: los mensajes que ve el consumidor (#90).
 *
 * `minimumRole: 'viewer'` y no `admin`: leer la copia publicada es exactamente
 * lo que hace el equipo de calidad, que mira y no toca, y es la pantalla donde
 * se comprueba qué está diciendo hoy la marca en las tres traducciones.
 * ESCRIBIRLA exige `admin` —lo aplica `PUT /api/v1/verification/messages`— y
 * dentro de la vista se esconde el botón que sólo podría terminar en 403.
 */
import type { ModuleRoutes } from '../module';
import { VerificationPage } from './VerificationPage';

export const moduleRoutes: ModuleRoutes = {
  moduleId: 'verification',
  minimumRole: 'viewer',
  routes: [{ path: '', element: <VerificationPage /> }],
};
